import React, { useContext } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
// import { CSSTransition } from 'react-transition-group';
// import * as AuthService from "../../../../services/AuthService";
import PATHS from "../../../../constants/paths";
// import { ROLE_SUPPORT } from "../../../../constants/index";
// import { Button } from '@smartups-sl/react-basic-components';
// import Menu, { Item as MenuItem } from 'rc-menu';
// import "rc-menu/assets/index.css";
import {
  IconStyled,
  ButtonOption,
  Logo,
  OffCanvasHeader,
  NavLink,
  ButtonOption2,
  NavLinkChild,
  IconArrow,
} from "./styled";
import { AuthContainer } from "../../../security/auth/auth.container";

// import { showDialog } from "@smartups-sl/react-utils-components";
import { Can, AbilityContext } from "../../../security/permissions/Can";
import { USER_PERMISSIONS } from "../../../security/permissions/rolesPermission";
import { checkBootstrapSizeBreak } from "../../../../utils/device/checkDevice";

// import { toast } from "react-toastify";

const Sidebar = (props) => {
  const auth = AuthContainer.useContainer();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { offCanvas } = props;
  const context = useContext(AbilityContext);
  const deviceSize = checkBootstrapSizeBreak();

  const logout = async () => {
    auth.logout();
    openCenteredPopup(
      `https://login.microsoftonline.com/99dbb24d-723f-44f0-b082-24b8ce4784d4/oauth2/logout`,
      `logout azureAd`,
      150,
      150
    );
  };

  const handlerSelectOption = async (key) => {
    switch (key) {
      case "toEval":
        navigate(PATHS.EVALUATION);
        break;
      case "home":
        navigate(PATHS.HOME);
        break;
      case "consult":
        navigate(PATHS.LIST_EVALUATION);
        break;
      case "evaluations":
        navigate(PATHS.RH_LIST_EVALUATION);
        break;
      case "config":
        navigate(PATHS.CONFIG);
        break;
      // case "calibration":
      //   navigate(PATHS.CALIBRATION);
      //   break;
      case "organigrama":
        navigate(PATHS.EVALUATION_ORG_CHART);
        break;
      case "reportResult":
        navigate(PATHS.REPORT_RES_FINAL);
        break;

      case "close_session":
        logout();
        break;

      default:
        break;
    }
  };

  return (
    <>
      <ul className="nav flex-column text-white w-100">
        {offCanvas && (
          <OffCanvasHeader className="offcanvas-header">
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </OffCanvasHeader>
        )}
        <a
          href={`${process.env.REACT_APP_PROTOCOL}://${
            process.env.REACT_APP_HOST
          }${
            process.env.REACT_APP_PORT ? `:${process.env.REACT_APP_PORT}` : ""
          }/client/home`}
          className="nav-link-logo text-center mb-4 mt-3"
        >
          <Logo
            src={`/assets/themes/${process.env.REACT_APP_THEME}/images/logo_ama.png`}
            alt="logo"
            className="logo"
            offCanvas={offCanvas}
          />
        </a>

        <NavLink href="#" className="selectable nav-link mt-2">
          {/* <span className="mx-2"> */}
          <ButtonOption
            $active={true}
            data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
            onClick={() => {
              handlerSelectOption("home");
            }}
          >
            <IconStyled className="fa-solid fa-gauge" />
            {t("home")}
          </ButtonOption>

          {/* </span> */}
        </NavLink>
        <Can do={USER_PERMISSIONS.TO_EVAL}>
          <NavLink href="#" className="selectable nav-link">
            {/* <span className="mx-2"> */}
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("toEval");
              }}
            >
              <IconStyled className="fa-solid fa-user-pen" />
              {t("toEval")}
            </ButtonOption>
            {/* </span> */}
          </NavLink>
        </Can>
        <Can do={USER_PERMISSIONS.TO_EVAL}>
          <NavLink href="#" className="selectable nav-link">
            {/* <span className="mx-2"> */}
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("consult");
              }}
            >
              <IconStyled className="fa-solid fa-users" />
              {t("myTeam")}
            </ButtonOption>
            {/* </span> */}
          </NavLink>
        </Can>
        <Can do={USER_PERMISSIONS.LIST_ALL_EVALUATIONS}>
          <NavLink href="#" className="selectable nav-link">
            {/* <span className="mx-2"> */}
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("evaluations");
              }}
            >
              <IconStyled className="fa-solid fa-magnifying-glass" />
              {t("evaluations")}
            </ButtonOption>
            {/* </span> */}
          </NavLink>
        </Can>
        {/* <Can do={USER_PERMISSIONS.SETTING}>
          <NavLink href="#" className="selectable nav-link"> */}
        {/* <span className="mx-2"> */}
        {/* <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("calibration");
              }}
            >
              <IconStyled className="fa-solid fa-file-arrow-up" />
              {t("calibration")}
            </ButtonOption> */}
        {/* </span> */}
        {/* </NavLink>
        </Can> */}
        <Can do={USER_PERMISSIONS.ORGANIGRAMA}>
          <NavLink href="#" className="selectable nav-link">
            {/* <span className="mx-2"> */}
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("organigrama");
              }}
            >
              <IconStyled className="fa-solid fa-sitemap" />
              {t("organigrama")}
            </ButtonOption>
            {/* </span> */}
          </NavLink>
        </Can>
        <Can do={USER_PERMISSIONS.VIEW_REPORT}>
          <NavLink href="#" className="selectable nav-link">
            {/* <span className="mx-2"> */}
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("reportResult");
              }}
            >
              <IconStyled className="fa-solid fa-chart-simple" />
              {t("reportResult")}
            </ButtonOption>
            {/* </span> */}
          </NavLink>
        </Can>
        <Can do={USER_PERMISSIONS.SETTING}>
          <NavLink href="#" className="selectable nav-link">
            {/* <span className="mx-2"> */}
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("config");
              }}
            >
              <IconStyled className="fa-solid fa-screwdriver-wrench" />
              {t("config")}
            </ButtonOption>
            {/* </span> */}
          </NavLink>
        </Can>
      </ul>
      <span href="#" className="nav-link w-100 mb-2">
        <ButtonOption2
          $active={true}
          onClick={() => {
            handlerSelectOption("close_session");
          }}
        >
          <IconStyled className="fas fa-power-off" />
          {t("close_session")}
        </ButtonOption2>
      </span>
    </>
  );
};

// Sidebar.contextType = AbilityContext;

Sidebar.propTypes = {
  nickname: PropTypes.string,
  offCanvas: PropTypes.bool,
};

export default Sidebar;

export const openCenteredPopup = (url, title, w, h) => {
  // Fixes dual-screen position                             Most browsers      Firefox
  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : window.screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : window.screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft;
  const top = (height - h) / 2 / systemZoom + dualScreenTop;
  const newWindow = window.open(
    url,
    title,
    `
      scrollbars=no,
      toolbar=no,
      location=no,
      directories=no,
      status=no,
      menubar=no,
      resizable=no,
      copyhistory=no,
      width=${w / systemZoom}, 
      height=${h / systemZoom}, 
      top=${top}, 
      left=${left}
      `
  );

  newWindow?.focus();

  setTimeout(() => {
    newWindow.close();
  }, 5000);
};
